import { render, staticRenderFns } from "./Originator.vue?vue&type=template&id=3a94a312&scoped=true"
import script from "./Originator.vue?vue&type=script&lang=js"
export * from "./Originator.vue?vue&type=script&lang=js"
import style0 from "./Originator.vue?vue&type=style&index=0&id=3a94a312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a94a312",
  null
  
)

export default component.exports